import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import ArrowBack from "../../common/images-new/arrow-back-black-icon.svg";
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import Comment from "../../components/LikeComment/Comment";
import AvatarGroup from "../../components/LikeComment/AvatarGroup";
import LikeComment from "../../components/LikeComment/LikeComment";
import PageWrapper from "../PageWrapper";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import { useParams } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { apiUrl, serverUrl } from "../../components/Helpers/Config";
import {
  getProfilePic,
  convertDateFormat,
  addAttribute,
} from "../../components/Helpers/Common";
import readingTime from "reading-time";
import CommentInput from "../../components/LikeComment/CommentInput";
import { staticFiles } from "../../components/Helpers/Static";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { ActiveIconColor, Card, TextGray } from "../Theme";
import JournalHashtag from "../../components/Button/JournalHashtag";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { Loading } from "../../components/Helpers/Common";
import { ButtonCommonTopNew, DivBadge } from "../Theme";
import { BiLeftArrowAlt } from "react-icons/bi";
import { MdDescription, MdKeyboardArrowLeft } from "react-icons/md";
import RichContent from "../../components/Editor/RichContent";
import SortToggle from "../../components/Button/SortToggle";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { defaultTheme } from "../Theme";
const FILE_UPLOAD = staticFiles.fileUpload;
const NO_IMAGE = staticFiles.noImage;

const PublicPostView = () => {
  const history = useHistory();
  const location = useLocation();

  // const params = useParams()

  const { postId, userId } = useParams();

  const myUserId = localStorage.getItem("user_id");
  const userProfile = useSelector((state) => state.auth.user);
  const profile = {
    name: userProfile ? userProfile.fullname : "",
    photo: userProfile ? userProfile.photo : hmenu_user,
  };

  const profileTheme =
    JSON.parse(localStorage.getItem("userTheme" + userId)) ?? defaultTheme;

  // let list = [{profilePic: profile.photo, username: profile.name, daysAgo:3, comment: commentText,
  //                     numLikes:14, numComments:5}]

  const [commentList, setCommentList] = useState([]);
  const [comment, setComment] = useState("");
  const [likesList, setLikesList] = useState([]);
  const [postData, setPostData] = useState({});
  const [toggleComment, setToggleComment] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [offsetComments, setOffsetComments] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [sortOrderInitial, setsortOrderInitial] = useState("desc");
  const [sortOrder, setsortOrder] = useState("desc");


  useEffect(() => {
    getPost(postId);
    getLikes(postId);
    let reflectionData = { reflection_id: postId };
    axios
      .post(serverUrl.ReflectionsReads, reflectionData)
      .then((resp) => {
        if (resp.status === 200) {
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  }, []);

  const goBack = () => {
    const prevPage =
      location.state && location.state.src
        ? location.state.src
        : `/profile/${userId}`;
    const tabId =
      location.state && location.state.tabId ? location.state.tabId : 0;

    history.push(prevPage, { tabId });
  };

  const getPost = (postId) => {
    return axios
      .get(serverUrl.ReflectionPost + "/" + postId)
      .then((resp) => {
        if (resp.status === 200) {
          let postData = resp.data.post;
          setPostData(postData);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        if (err.response && err.response.status === 404) {
          history.push("/post-not-found");
        } else {
          console.log(err);
        }
      });
  };

  const getLikes = (postId) => {
    return axios
      .get(apiUrl + "likes/" + postId)
      .then((resp) => {
        if (resp.status === 200) {
          let likesList = resp.data.results;
          setLikesList(likesList);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const getComments = (offset) => {
    return axios
      .get(
        apiUrl +
        "comments/" +
        postId +
        "?sort_order=" +
        sortOrderInitial +
        "&limit=10&offset=" +
        offset
      )
      .then((resp) => {
        if (resp.status === 200) {
          let data = [];
          data = resp.data.results;
          if (resp.data.results?.length > 9) {
            setHasMoreComments(true);
          } else {
            setHasMoreComments(false);
          }
          data = [...data, ...commentList];
          if (sortOrder == "asc") {
            const ascSortedData = data
              ?.slice()
              .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
            setCommentList(ascSortedData);
          }
          if (sortOrder == "desc") {
            const descSortedData = data
              ?.slice()
              .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            setCommentList(descSortedData);
          }
          setLoadingComments(false);
          // let newCommentList = resp.data.results
          // setCommentList(newCommentList)
        } else {
          setLoadingComments(false);
        }
      })
      .catch((err) => {
        setLoadingComments(false);
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };
  const handleSort = (str) => {
    setsortOrder(str);
    localStorage.setItem("sortOrder", str);
    if (str == "asc") {
      const ascSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
      setCommentList(ascSortedData);
    }
    if (str == "desc") {
      const descSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCommentList(descSortedData);
    }
    // getComments(postId, str)
  };

  const handleCommentClick = () => {
    setToggleComment(!toggleComment);
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
      setsortOrder(str);
    }
    if (!toggleComment === false) {
      // dispatch(getShowcases());
      setCommentList([]);
      getPost(postId);
      setOffsetComments(0);
      setHasMoreComments(false);
      setsortOrderInitial(str);
    }
    if (!toggleComment === true) {
      setLoadingComments(true);
      getComments(offsetComments);
    }
    // if (!toggleComment === false) {
    //     setsortOrder("desc")
    // }
    // getComments(str)
  };

  const likePost = (isLiked) => {
    return axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: postId,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          getPost(postId);
          getLikes(postId);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const commentPost = (commentText, isPublic) => {
    return axios
      .post(serverUrl.ReflectionPost + "/comment", {
        reflection_id: postId,
        comment: commentText,
        visibility: isPublic,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let str = sortOrder;
          if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder");
            setsortOrder(str);
          }
          postData.comments_count = postData.comments_count + 1;
          let object = [
            {
              photo: userProfile?.photo,
              fullname: userProfile?.fullname,
              created_on: new Date(),
              guid: userProfile?.guid,
              reflection_comment_id: resp.data?.reflection_comment_id,
              user_id: resp.data?.user_id,
              comments: commentText,
              visibility: isPublic,
            },
          ];
          if (toggleComment == false) {
            setCommentList([]);
            setOffsetComments(0);
            setToggleComment(true);
            getComments(offsetComments);
          } else {
            if (str == "desc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...object, ...commentList]);
              }
            }
            if (str == "asc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...commentList, ...object]);
              }
            }
          }
          setComment("");
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const loadMoreComments = () => {
    setLoadingComments(true);
    let count = offsetComments + 10;
    setOffsetComments(offsetComments + 10);
    getComments(count);
  };

  const minutesRead = postData?.reflection_content
    ? readingTime(postData.reflection_content).text
    : null;

  return (
    <PageWrapper hideNav={true} tempTheme={profileTheme}>
      <div className="border20px overflow-hidden cardBackgroundColor pt-6 relative shadow-md">
        <div className="">
          <div className="flex flex-col sm:flex-row pb-4 px-5 md:px-28 lg:px-36">
            {/* <ButtonCommonTopNew
                            className="rounded-lg px-5 py-2 flex items-center w-max cursor-pointer"
                            onClick={goBack}
                        >
                            <BiLeftArrowAlt className="w-5 h-5" />
                            <h1 className="text-xs lg:text-sm">Back</h1>
                        </ButtonCommonTopNew> */}
            <div
              className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
              onClick={goBack}
            >
              <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
              <h1 className="text-lg blueColor font-semibold">Back</h1>
            </div>
            <p className="text-xl flex justify-center items-center w-full font-semibold blackColor">
              {postData?.reflection_title}
            </p>
          </div>
          <div className="flex flex-row lg:flex-row items-center relative gap-2 px-5 md:px-28 lg:px-36">
            <Link to={"/profile/" + postData.guid}>
              <img
                className="h-10 w-10 rounded-full cursor-pointer"
                src={getProfilePic(postData.profile_pic)}
                alt="profile"
              ></img>
            </Link>
            <div className="flex flex-col text-left">
              <div className="flex blackColor gap-1">
                by
                <Link
                  to={"/profile/" + postData.guid}
                  className="break-words nav-navigate"
                >
                  <ActiveIconColor className="hover:underline text-base font-semibold">
                    {postData.username}
                  </ActiveIconColor>
                </Link>
              </div>
              {/* <span className="lightColor text-sm flex items-center">
                {moment
                  .utc(postData?.reflection_updated_on)
                  .local()
                  .startOf("seconds")
                  .fromNow()}{" "}
                ({convertDateFormat(postData?.reflection_updated_on)})
              </span> */}
              <TextGray className="text-sm font-normal flex items-center gap-1">
                {moment
                  .utc(postData?.reflection_updated_on)
                  .local()
                  .startOf("seconds")
                  .fromNow()}
                <span>
                  ({convertDateFormat(postData?.reflection_updated_on)})
                </span>{" "}
                - {minutesRead}
                <span className="flex items-center gap-0">
                  {postData?.reflection_address && (
                    <>
                      <LocationOnIcon
                        className="text-red-600 "
                        style={{ fontSize: "18px" }}
                      />
                      {postData.reflection_address}
                    </>
                  )}
                </span>
              </TextGray>
            </div>
          </div>
          <div className="px-5 md:px-28 lg:px-36">
            <div className="flex flex-row flex-wrap gap-2 my-3">
              {postData.hashtag &&
                postData.hashtag.map((hashtag, index) => (
                  <JournalHashtag key={index} text={hashtag} color="blue" />
                ))}
              {postData.values &&
                postData.values.map((value, index) => (
                  <ButtonHashtag
                    key={index}
                    text={value.value}
                    color="orange"
                  />
                ))}
              {postData.events &&
                postData.events.map((events, index) => (
                  <ButtonHashtag
                    key={index}
                    text={events.value}
                    color="green"
                  />
                ))}
              {postData.courses &&
                postData.courses.map((course, index) => (
                  <ButtonHashtag key={index} text={course.value} color="red" />
                ))}
              {postData.groups &&
                postData.groups.map((group, index) => (
                  <JournalHashtag key={index} text={group.value} color="blue" />
                ))}
            </div>

            {postData.docs && (
              <div className="flex flex-wrap w-full gap-2 my-3">
                {postData.docs.map((item, idx) => {
                  let itemName = item ? item : null;

                  if (itemName) {
                    const itemUrl = itemName;
                    const lastSlash = itemName.lastIndexOf("/");

                    if (lastSlash !== -1) {
                      itemName = itemName.substr(
                        lastSlash + 1,
                        itemName.length - lastSlash - 1
                      );
                    }
                    return (
                      <DivBadge
                        key={idx}
                        className="flex flex-row items-center rounded-lg px-2 justify-center w-max"
                      >
                        <MdDescription className="w-5 h-5 text-white" />
                        <a
                          href={itemUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex text-sm p-1 nav-navigate"
                        >
                          <div className=" text-white">{itemName}</div>
                        </a>
                      </DivBadge>
                    );
                  }
                  return null;
                })}
              </div>
            )}

            {/* Post Body */}
            {postData.reflection_image &&
              postData.reflection_image.length > 0 && (
                <img
                  className="border20px object-contain max-w-full h-auto mx-auto"
                  src={postData.reflection_image}
                  alt={postData.reflection_title}
                  onError={(e) => {
                    e.target.src = NO_IMAGE;
                  }}
                />
              )}
            <RichContent
              className="mt-5 break-words"
              content={addAttribute(postData.reflection_content)}
            />
            {/* Likes and comments */}
          </div>
          <hr className="my-4" />
          <div className="px-5 md:px-28 lg:px-36">
            <div className="my-2">
              <CommentInput
                comment={comment}
                setComment={setComment}
                commentPost={commentPost}
                profilePhoto={profile.photo}
              />
            </div>
            <div className="flex flex-row items-center gap-4 my-2">
              {likesList?.length > 0 ? (
                <AvatarGroup likesList={likesList} />
              ) : null}
              <LikeComment
                currentIsLiked={parseInt(postData?.like)} // this data is not available in get single post
                numLikes={likesList?.length}
                numComments={postData?.comments_count}
                likesList={likesList}
                handleComment={handleCommentClick}
                handleLike={() =>
                  likePost(parseInt(postData.like) === 1 ? 0 : 1)
                } // not functional yet
              />
            </div>
          </div>
          <div className="backgroundColor8 px-5 md:px-28 lg:px-36 rounded-b-2xl border mt-4">
            <div className="items-center relative my-3">
              {postData?.comments_count != 0 && (
                <>
                  <div className="flex flex-col sm:flex-row items-center justify-between mt-2">
                    <p className="text-base font-semibold blackColor">
                      Comments ({postData?.comments_count})
                    </p>
                    {toggleComment == true && (
                      <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                    )}
                  </div>
                </>
              )}
              {toggleComment === true ? (
                commentList &&
                commentList.map((comment, index) => (
                  <Comment
                    key={index}
                    order={index}
                    profilePic={comment.photo}
                    username={comment.fullname}
                    createdOn={comment.created_on}
                    comment={comment.comments}
                    // handleDelete={() => deleteComment(comment.reflection_comment_id)}
                    //deleteView={true}
                    userId={comment.user_id}
                    guID={comment.guid}
                    isPrivate={comment.visibility}
                  // numLikes = {comment.numLikes}
                  // numComments = {comment.numComments}
                  />
                ))
              ) : (
                <>
                  {postData?.latest_comment ? (
                    <Comment
                      // key={index}
                      // order={index}
                      profilePic={postData?.latest_comment?.photo}
                      username={postData?.latest_comment?.fullname}
                      createdOn={postData?.latest_comment?.created_on}
                      comment={postData?.latest_comment?.comment}
                      // handleDelete={() => deleteComment(post?.latest_comment?.reflection_comment_id)}
                      deleteView={true}
                      // userId={post?.latest_comment?.user_id}
                      // isView={isView}
                      guID={postData?.latest_comment?.user_guid}
                      isPrivate={postData?.latest_comment?.visibility}
                    />
                  ) : (
                    <p className="lightColor text-sm">
                      There is no comment yet.
                    </p>
                  )}{" "}
                </>
              )}
            </div>
            {loadingComments && (
              <div className="grid grid-cols-1 my-4">
                <div className="justify-center justify-self-center">
                  <Loading active={loadingComments} />
                </div>
              </div>
            )}
            {toggleComment && hasMoreComments && (
              <div className="grid grid-cols-1 h-14">
                <div className="justify-center justify-self-center">
                  <ButtonCommonTopNew
                    className="flex items-center justify-center border p-2 rounded-lg cursor-pointer text-sm"
                    onClick={loadMoreComments}
                  >
                    Load more
                  </ButtonCommonTopNew>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default PublicPostView;
